/**
 * Which agreement prompt the user put off for this session (#4494).
 *
 * The prompt never blocks work, so *Later* has to hold — but only until the next sign-in.
 * `sessionStorage` plus {@link forgetAgreementPromptDismissal} at sign-out is exactly that: a
 * reload keeps it put off, signing in again asks again.
 *
 * What is stored is the question that was put off — the organisation and each outstanding
 * document at its version — so a version published after the dismissal, or a switch to another
 * organisation, is asked about anyway. Storage is a convenience on both sides: a browser that
 * refuses it asks again on reload, which is the harmless direction.
 */
const DISMISSED_KEY = 'scrivio_agreement_prompt_dismissed'

/** Put off [question] until the next sign-in. */
export function dismissAgreementPrompt(question: string): void {
  try {
    sessionStorage.setItem(DISMISSED_KEY, question)
  } catch {
    // Storage refused: the prompt returns on reload, which blocks nothing
  }
}

/** Whether [question] — and not merely an earlier one — was put off in this session. */
export function isAgreementPromptDismissed(question: string): boolean {
  try {
    return sessionStorage.getItem(DISMISSED_KEY) === question
  } catch {
    return false
  }
}

/** Forget any dismissal, so the next sign-in asks again. Called when the user signs out. */
export function forgetAgreementPromptDismissal(): void {
  try {
    sessionStorage.removeItem(DISMISSED_KEY)
  } catch {
    // Nothing stored that could be forgotten
  }
}
